import { extractSearchParams } from "@bloomreach/spa-sdk";
export function buildConfiguration(path, httpClient, baseUrl, endpoint, hasMultiTenantSupport) {
  const configuration = {
    path
  };
  configuration.baseUrl = baseUrl;
  if (endpoint) {
    configuration.endpoint = endpoint;
  } else if (hasMultiTenantSupport) {
    const endpointQueryParameter = "endpoint";
    const { url, searchParams } = extractSearchParams(path, [endpointQueryParameter].filter(Boolean));
    configuration.endpoint = searchParams.get(endpointQueryParameter) ?? "";
    configuration.baseUrl = `?${endpointQueryParameter}=${searchParams.get(endpointQueryParameter)}`;
    configuration.path = url;
  }
  configuration.httpClient = httpClient;
  return configuration;
}
